import { useEffect, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function RouteReset(){
  const location=useLocation()
  useEffect(()=>{if('scrollRestoration' in history)history.scrollRestoration='manual'},[])
  useLayoutEffect(()=>{
    if(location.hash)return
    const reset=()=>window.scrollTo({top:0,left:0,behavior:'auto'})
    reset()
    const raf=requestAnimationFrame(reset)
    const t1=window.setTimeout(reset,40)
    const t2=window.setTimeout(reset,160)
    return()=>{cancelAnimationFrame(raf);window.clearTimeout(t1);window.clearTimeout(t2)}
  },[location.pathname,location.search,location.key])
  return null
}
